import { CoreApi } from '@inter-ikea-storageone/range';
import getPanelProductIds from './getPanelProductIds';
import getPanelArrangement from './getPanelArrangement';
import panelLayoutConfig from '../panelLayoutConfig';
import { PanelArrangement } from '@inter-ikea-storageone/range-pax';
import PanelSelection from '../types/PanelSelection';
import { Entity } from '@inter-ikea-core/core';

const getPanelProductSelectionIds: (
  doorEntity: Entity,
  coreApi: CoreApi
) => { [PanelSelection.Primary]: string; [PanelSelection.Secondary]: string } | null = (
  doorEntity,
  coreApi
) => {
  const panelProductIds = getPanelProductIds(doorEntity, coreApi);
  if (panelProductIds === null) {
    return null;
  }

  const panelArrangement = getPanelArrangement(doorEntity, coreApi);
  if (panelArrangement === PanelArrangement.Unknown) {
    return null;
  }

  if (panelArrangement === PanelArrangement.Solid) {
    return {
      primary: panelProductIds[0],
      secondary: panelProductIds[0]
    };
  }

  const panelLayout = panelLayoutConfig.find(
    panelLayout => panelLayout.arrangement === panelArrangement
  )!;

  const panelIndexPrimary = panelLayout.layout.indexOf(PanelSelection.Primary);
  const panelIndexSecondary = panelLayout.layout.indexOf(PanelSelection.Secondary);

  return {
    primary: panelProductIds[panelIndexPrimary],
    secondary: panelProductIds[panelIndexSecondary]
  };
};

export default getPanelProductSelectionIds;
